<!-- Start Page Title Area -->
<div class="page-title-area">
    <div class="container">
        <div class="page-title-content">
            <h2>永續專區ESG</h2>
            <h2 style="padding-top: 10px;">E環境保護</h2>
        </div>
    </div>
</div>
<!-- End Page Title Area -->

<!-- Start About Area -->
<!-- <section class="about-area ptb-50">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd;">口號</h3>
                <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p>
            </div>
        </div>
    </div>
</section> -->
<!-- End About Area -->

<div class="ptb-50">

</div>
<section class="section-title"
    style="margin-top:0px; background-image: url(../../../../assets/img/main/bg-1.png);background-repeat: no-repeat;background-size: 100% 100%;">
    <div class="row">
        <div class="col"></div>
        <div class="section-title">
            <h2 style="color: white; padding-top: 30px; ">碩於心，達於行，共創綠色地球</h2>
        </div>
        <div class="col"></div>
    </div>
</section>
<section class="about-area ptb-20">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd;">碩達簽署及響應淡水河公約宣告</h3>
                <!-- <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p> -->
            </div>
        </div>
    </div>
</section>

<section class="features-area ptb-20">
    <div class="container" style="max-width: 100%;padding-left: 0px;padding-right: 0px;background-color: white;">
        <div style="text-align: center;padding-top: 0px;" class="ptb-50">
            <a style="display: inline">
                <img style="width:50%" src="assets/img/esg/1.png">
            </a>
        </div>
    </div>
</section>

<section class="about-area ptb-20">
    <div class="container" style="max-width: 90%;">
        <div class="overview-box">
            <div class="content">
                <h3 style="color: #2781bd;">2024碩達世界地球日宣導</h3>
                <!-- <p style="color: black;">拉丁文中 Solar 代表太陽的~，英文中 maximum 代表最大值，將兩者結合成為 Solarix，代表碩達旭日爭光、躡景追風，在詭譎多變的全球市場，不斷磨練精進，提升專業技能，尋找最佳方案，成為企業轉型最佳夥伴；以誠信作為商業經營基石，專業建構企業核心，彈性敏捷串聯內外運作，開放人員自律養成，積極正面且熱情的態度對待每一個客戶，期望與客戶攜手並進在灰暗中迎向光明，在挑戰中突破極限創造未來。</p> -->
            </div>
        </div>
    </div>
</section>

<section class="features-area ptb-20">
    <div class="container" style="max-width: 100%;padding-left: 0px;padding-right: 0px;background-color: white;">
        <div style="text-align: center;padding-top: 0px;" class="ptb-50">
            <a style="display: inline;">
                <img style="width:50%" src="assets/img/esg/2.png">
            </a>
        </div>
    </div>
</section>